(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileGoogleMailEmailInfo', ["path", "$q", "mainQueueTroubleshootingHelper", "widgetPolling", "modals", "rolesManager", "$rootScope", function (path, $q, mainQueueTroubleshootingHelper, widgetPolling, modals, rolesManager, $rootScope) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/google_mail_email/email-info').template('email-info'),
            scope: { shared: '=?profileGoogleMailEmailInfo' },
            link: function ($scope, element, attrs) {
                var titlePrefix = $scope.shared.titlePrefix ? $scope.shared.titlePrefix + '#' + JSON.stringify({
                    display: 'text',
                    text: ' - ',
                    'class': 'title-saas-dash'
                }) : '';
                $scope.shared.title = $scope.shared.titlePrefix;
                $scope.shared.titleClass = {};
                $scope.widgetApi = {};
                $scope.loadData = function () {
                    return $q.when();
                };
                $scope.infoWidget = {
                    type: 'meta-info',
                    logic: {
                        name: 'emailMetaInfoLogic',
                        beautifyKey: true,
                        blackList: ['subject'],
                        subjectField: 'subject',
                        subjectTitle: false,
                        advanced: true,
                        entityDataMaster: true,
                        converters: { from: { converter: 'viewAllEmailsDebugLinkConverter' } }
                    },
                    uuid: '1e27df67-27de-46f9-a145-630d19fded6f',
                    wrapper: { type: 'none' },
                    pair: { 'class': 'email-meta-data' }
                };
                $scope.restoreRequestWidget = {
                    type: 'info',
                    logic: {
                        name: 'emailRestoreRequestLogic',
                        entityDataSlave: true
                    },
                    'class': 'restore-request-widget',
                    style: { display: 'none' },
                    wrapper: { type: 'none' }
                };
                $scope.actionsWidget = {
                    type: 'actions',
                    logic: {
                        name: 'remediationActionsLogic',
                        updateTick: 30000,
                        entityType: 'google_mail_email',
                        entityDataSlave: true
                    },
                    'class': 'file-info-actions-widget wide-250-buttons',
                    wrapper: { type: 'none' },
                    actions: rolesManager.isActionAllowed([
                        'admin',
                        'user',
                        'operations'
                    ]) ? [
                        {
                            autoId: 'profile_manual_action_btn_google_mail_email_quarantine',
                            'class': 'btn btn-blue',
                            style: { width: '100%' },
                            actionType: 'google_mail_email_quarantine',
                            disabledEntityAll: {
                                is_quarantined: true,
                                is_deleted_message: true
                            },
                            hiddenEntityAny: {
                                is_quarantined_notification: true,
                                is_quarantined_user_notification: true,
                                is_sent_from_internal: true
                            },
                            hiddenEntityAll: [
                                {
                                    is_deleted_message: true,
                                    is_quarantined: false
                                },
                                {
                                    is_restored_from_quarantine: true,
                                    workflow: {
                                        operator: 'not_partof',
                                        value: 'none, user, admin'
                                    }
                                }
                            ]
                        },
                        {
                            autoId: 'profile_manual_action_btn_google_mail_email_restore',
                            'class': 'btn btn-blue',
                            style: { width: '100%' },
                            actionType: 'google_mail_email_restore',
                            additionalAction: 'release_to_all_recipients',
                            hiddenEntityAny: {
                                is_quarantined: {
                                    operator: 'not_equal',
                                    value: true
                                }
                            },
                            disabledEntityAny: { is_quarantined_restored: true },
                            feature: 'emailRestore'
                        },
                        {
                            autoId: 'profile_manual_action_btn_google_mail_email_restore_decline',
                            'class': 'btn btn-blue',
                            style: { width: '100%' },
                            actionType: 'google_mail_email_restore_decline',
                            hiddenEntityAny: {
                                is_quarantined: {
                                    operator: 'not_equal',
                                    value: true
                                },
                                is_restore_declined: true,
                                restoration_requested: false,
                                is_quarantined_restored: true
                            },
                            feature: 'emailRestore'
                        },
                        {
                            autoId: 'profile_manual_action_btn_google_mail_email_restore_original',
                            actionType: 'google_mail_email_restore_original',
                            hiddenEntityAny: {
                                is_attachment_changed: {
                                    operator: 'not_equal',
                                    value: true
                                }
                            },
                            disabledEntityAny: { is_attachment_restored: true },
                            feature: 'attachmentRestore'
                        },
                        {
                            autoId: 'profile_manual_action_btn_google_mail_email_send_original',
                            actionType: 'google_mail_email_send_original',
                            hiddenEntityAny: {
                                is_deleted_message: {
                                    operator: 'not_equal',
                                    value: false
                                },
                                is_quarantined: {
                                    operator: 'not_equal',
                                    value: false
                                },
                                is_restored_from_quarantine: {
                                    operator: 'not_equal',
                                    value: false
                                }
                            },
                            hiddenSecEntityAny: { clicktime_protection: { result: 'no_links_replaced' } }
                        }
                    ] : []
                };
                $scope.filters = {
                    uuid: '1e27df67-27de-46f9-a145-630d19fded6f',
                    filters: [{
                            type: 'flag',
                            text: 'Advanced',
                            value: 'advanced',
                            local: true
                        }]
                };
                var debugAllEmailsWidget = {
                    type: 'data-table',
                    logic: {
                        name: 'allUserEmailsLogic',
                        updateTick: null
                    },
                    options: {
                        pagesAround: 2,
                        pageSize: 20,
                        pagination: { page: 1 },
                        disableTop: true,
                        dropdownHeader: true,
                        defaultOrdering: {
                            columnName: 'internalDate',
                            order: 'desc'
                        }
                    },
                    'class': 'light medium-icons',
                    wrapper: {
                        type: 'widget-panel',
                        title: 'All Emails with User',
                        'class': 'avanan white-body overflow-auto'
                    },
                    bodyStyle: { height: 'calc(100vh - 170px)' },
                    columns: [
                        {
                            id: 'entity_id',
                            hidden: true
                        },
                        {
                            id: 'internalDate',
                            text: 'Received',
                            format: 'time',
                            sortable: true,
                            'class': 'one-line-date',
                            filter: {
                                type: 'date',
                                name: 'internalDate_filter'
                            }
                        },
                        {
                            id: 'from',
                            text: 'From',
                            sortable: true,
                            converter: 'highlightUserEmailConverter',
                            filter: {
                                type: 'text',
                                name: 'from_filter'
                            }
                        },
                        {
                            id: 'recipients',
                            text: 'Recipients',
                            converter: 'listConverter',
                            converterArgs: {
                                itemConverter: 'highlightUserEmailConverter',
                                countPostfix: 'recipients',
                                collapseRest: true,
                                expanded: 4
                            },
                            filter: {
                                type: 'text',
                                name: 'recipients_filter'
                            }
                        },
                        {
                            id: 'subject',
                            text: 'Subject',
                            sortable: true,
                            href: {
                                type: 'email',
                                params: {
                                    id: 'entity_id',
                                    emptyLinkText: 'Missing subject - click here for the email'
                                }
                            },
                            filter: {
                                type: 'text',
                                name: 'subject_filter'
                            },
                            dropdownPosition: 'left'
                        }
                    ]
                };
                $scope.$on('show-all-user-emails', function (event, data) {
                    if (debugAllEmailsWidget.logic.userId !== data.userId) {
                        delete debugAllEmailsWidget.data;
                        debugAllEmailsWidget.logic.userId = data.userId;
                        debugAllEmailsWidget.wrapper.Loading = true;
                    }
                    delete debugAllEmailsWidget.options.pagination.columnsFilters;
                    modals.widget({
                        panel: debugAllEmailsWidget,
                        windowClass: 'size-xl',
                        closeOnNavigate: true
                    });
                });
                $scope.mainQueueDebug = mainQueueTroubleshootingHelper.button();
                $scope.$watch('infoWidget.entityData', function () {
                    if (!$scope.infoWidget.entityData || _($scope.infoWidget.entityData).isEmpty()) {
                        return;
                    }
                    if ($scope.infoWidget.entityData.originalPhishingMessageId) {
                        widgetPolling.scope().originalId = $scope.infoWidget.entityData.originalPhishingMessageId;
                    }
                    $scope.shared.entityInfoLoaded = true;
                    $scope.restoreRequestWidget.entityData = $scope.infoWidget.entityData;
                    $scope.actionsWidget.entityData = $scope.infoWidget.entityData;
                    $scope.actionsWidget.secEntityData = $scope.infoWidget.secEntityData;
                    if ($scope.infoWidget.entityData && $scope.infoWidget.entityData.subject) {
                        $scope.shared.title = titlePrefix + '#' + JSON.stringify({
                            display: 'linked-text',
                            'class': 'profile-title-container',
                            text: '"' + '#' + JSON.stringify({
                                display: 'text',
                                'class': 'email-subject',
                                text: $scope.infoWidget.entityData.subject
                            }) + '"'
                        });
                        $scope.shared.titleClass['subject-title'] = true;
                    }
                });
                $scope.$on('$locationChangeStart', function () {
                    $rootScope.isOpenedModal = false;
                });
            }
        };
    }]);
}());